import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { FormError } from '@/components/ui/form-error';
import { SegmentedControl } from '@/components/ui/segmented-control';
import { MAX_DATE_INPUT } from '@/utils/date';
import type { OrderFormBase } from './schema';

const deliveryModeOptions = [
  { value: 'date', label: '期日指定' },
  { value: 'asap', label: '即納希望' },
] as const;

export const DeliveryDateSection = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<OrderFormBase>();
  const deliveryMode = useWatch({ control, name: 'deliveryMode' });

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-3">
        <span className="font-bold">希望納期</span>
        <Controller
          control={control}
          name="deliveryMode"
          render={({ field }) => (
            <SegmentedControl
              ariaLabel="希望納期の指定方法"
              options={deliveryModeOptions}
              value={field.value}
              onChange={field.onChange}
              className="w-48"
            />
          )}
        />
      </div>
      {deliveryMode === 'date' && (
        <div>
          <input
            type="date"
            max={MAX_DATE_INPUT}
            aria-label="希望納期"
            className="h-11 md:h-10"
            {...register('desiredDeliveryDate')}
          />
          <FormError message={errors.desiredDeliveryDate?.message} />
        </div>
      )}
    </div>
  );
};
